export default __webpack_public_path__ + "static/media/isloation-beim-stumpfaufbau.84970636.png";